import enquire from 'enquire.js';

export default {
    data() {
        return {
            isCollapsed: false,
            showToggle: false,
        };
    },
    mounted() {
        const self = this;
        enquire.register('screen and (max-width: 800px)', {
            match() {
                self.isCollapsed = true;
                self.showToggle = true;
            },
            unmatch() {
                self.isCollapsed = false;
                self.showToggle = false;

            },
        });
    },
    methods: {
        toggle() {
            this.isCollapsed = !this.isCollapsed;
        },
    },
};
